import { api, getWithOptionalAuthorizationGeneric } from './api';
import { TRIP_MANAGEMENT_BASE } from './apiConstant';
import { getToken } from './auth';
import { decryptMessage } from '../utils/decrypt';

export type TripResponse = {
  id: string;
  tripName: string;
  fileName: string;
  fileUrl: string;
  mobileFileUrl: string;
  createdAt: string;
  direction: number;
  description: string;
};


const tripManagementApi = {

  getTripManagementByDirectionId : async (seasonalDirection: number): Promise<TripResponse> => {
    try {
      const encryptedTripManagementResponse = await getWithOptionalAuthorizationGeneric<TripResponse[]>(`${TRIP_MANAGEMENT_BASE}/${seasonalDirection}`, true);
      const tripManagementResponse = await decryptMessage(encryptedTripManagementResponse.data.Data, getToken());
      return tripManagementResponse;
    } catch (error) {
      console.error('Error fetching trip management:', error);
      throw error;
    }
  }
};

export default tripManagementApi;